import AppRouter from './AppRouter';

export { AppRouter };
export default AppRouter;
